export const getMapsLink = (address: string) => {
	const isIOS =
		/iPad|iPhone|iPod/.test(navigator.userAgent) &&
		!(window as Window & { MSStream?: unknown }).MSStream;
	const encodedAddress = encodeURIComponent(address);

	if (isIOS) {
		return `maps://?q=${encodedAddress}`;
	}
	return `https://maps.google.com/?q=${encodedAddress}`;
};
